<div class="modal-header total-raised-modal-header">
    <h5 class="modal-title">Total Raised</h5>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Close click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body total-raised-modal-body pt-md-5 pb-md-5">

    <div class="total-item">
        <span>Funds from LLS Fundraising Page</span>
        <span>${{donationsReceived | number: '1.2-2'}}</span>
    </div>

    <div *ngIf="!isNationalTeam" class="total-item">
        <span>Facebook Funds</span>
        <span>${{facebookDonationsAmount | number: '1.2-2'}}</span>
    </div>

    <div *ngIf="!isNationalTeam" class="total-item" >
        <span>Matching Gifts</span>
        <span>${{promises | number: '1.2-2'}}</span>
    </div>

    <div *ngIf="!!isNationalTeam" >
        <div class="total-item">
            <span>Promises</span>
            <span>${{promises | number: '1.2-2'}}</span>
        </div>
        <div class="total-item">
            <span>Sponsorships</span>
            <span>${{sponsorships | number: '1.2-2'}}</span>
        </div>
    </div>

</div>
<div class="modal-footer total-raised-modal-footer">
    <h5 class="modal-title">Grand Total</h5> <h5 class="modal-title">${{totalRaised | number: '1.2-2'}}</h5>
</div>
